export const InputValidation = {
  //Email : proper email format
  emailValidation: (input) => {
    const regex = RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
    return input === "" ? false : !regex.test(input);
  },

  //Password: One capital letter,One number,One special char, (6-10)
  passwordValidation: (input) => {
    const regex = RegExp(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/
    );

    return input === "" ? false : !regex.test(input);
  },
  //ProviderUserName Validation
  ProviderUserNameValidation: (input) => {
    const regex = RegExp(/^.{5,200}$/);
    return input === "" ? false : !regex.test(input);
  },
  //name validation
  nameValidation: (input) => {
    const regex = RegExp(/^[a-zA-Z ]{2,30}$/);
    return input === "" ? false : !regex.test(input);
  },
  //VIN
  vinValidation: (input) => {
    const regex = RegExp(/^[a-zA-Z0-9]{17}$/);
    return input === "" || null ? false : !regex.test(input);
  },
  //phone validation
  numberValidation: (input) => {
    const regex = RegExp(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/);
    return input === "" ? false : !regex.test(input);
  },
  //phone number format
  phoneNumberFormat: (number) => {
    const phoneNumber = number.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)})${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  },

  //zip code format

  zipCodeValidation: (input) => {
    const regex = RegExp(/^\d{5}$/);
    return input === "" ? false : !regex.test(input);
  },

  negativeValidation: (input) => {
    const regex = /^(?:\d+|\d*\.\d+)$/;
    return input === "" ? false : !regex.test(input) || input < 0;
  },
  addressValidation: (input) => {
    const regex = /^[a-zA-Z0-9 !@#$%^&*()_+{}\[\]:;<>,.?~\\/-]{2,}$/;
    return input === "" ? false : !regex.test(input);
  },

  //OTP validation

  otpValidation: (input) => {
    const regex = /^\d{6}$/;
    return input === "" ? false : !regex.test(input);
  },

  dateFormat: (date) => {
    const digits = date.replace(/\D/g, "").substring(0, 8);
    const length = digits.length;

    if (length <= 2) {
      return digits;
    } else if (length <= 4) {
      return `${digits.slice(0, 2)}/${digits.slice(2)}`;
    } else {
      return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(
        4,
        8
      )}`;
    }
  },

  // dateValidation: (input) => {
  //   const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[01])\/(19|20)\d{2}$/;
  //   return input === "" ? false : regex.test(input);
  // },

  dateValidation: (input) => {
    const regex = /(0[1-9]|1[1,2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}/;
    return input === "" ? true : regex.test(input);
  },

  employeeCodeValidation: (input) => {
    const regex = /^[A-Za-z]{2}\d{4}$/; // 2 letters + 4 digits (e.g. KP0055)
    return input === "" ? true : !regex.test(input);
  },

  dealercodeValidation: (input) => {
    const regex = /^[A-Za-z]{2}\d{3}$/; // exactly 3 letters followed by 2 digits
    return input === "" ? true : !regex.test(input);
  },
};
